import { render, staticRenderFns } from "./AutoSacrificeAdvancedTab.vue?vue&type=template&id=1bc626ee&scoped=true"
import script from "./AutoSacrificeAdvancedTab.vue?vue&type=script&lang=js"
export * from "./AutoSacrificeAdvancedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc626ee",
  null
  
)

export default component.exports